/**
 * Dynamite override for the PDP UGC carousel heading.
 *
 * Realm 1 (SFRA) Dynamite spec: the "Styled By You" label renders exactly as
 * authored (no casing change) with the regular weight. Only the heading deltas
 * live here; the shared metrics are in
 * theme/components/project/ugc-pdp-carousel.js.
 */
export default {
    baseStyle: {
        heading: {
            fontWeight: 'normal',
            textTransform: 'none'
        }
    }
}
